import styled from 'styled-components';

export const FloorPlansWrapper = styled.div`
  background-color: #ffffff;
  padding: 0px;
  margin: 0px;
`;
